import styled from 'styled-components';
import { Table } from '_components/_core';

export const StyledTable = styled(Table)`
  max-width: 50%;
  margin-left: auto;
  margin-right: auto;
`;
